import React from 'react';

function MenuSeparatorComponent() {
  return (
    <div
      data-test-id="selection-menu-separator"
      className="border-b border-light my-1 mx-2"
      style={{ height: '1px' }}
    />
  );
}

export { MenuSeparatorComponent };
